import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import styled from 'styled-components';
import { appTheme } from '../../theme';
import { mediaQuery } from './util/style';
import { em } from 'polished';

const AddButtonBase = styled(Button)`
  justify-content: flex-start;
  padding-left: ${appTheme.spacing.small};
  padding-right: ${appTheme.spacing.small};
`;

const AddButtonWrapper = styled.div`
  display: flex;
  margin-bottom: ${em(appTheme.spacing.large)};
  margin-top: ${em(appTheme.spacing.large)};

  ${mediaQuery.xsmall`
    justify-content: center;
  `};
`;

const AddIcon = styled(Icon)`
  margin-right: ${appTheme.spacing.small};
`;

function AddButton({ children, onClick }) {
  return (
    <AddButtonWrapper>
      <AddButtonBase onClick={onClick} variant="text">
        <AddIcon color="primary">
          <AddCircleIcon />
        </AddIcon>
        {children}
      </AddButtonBase>
    </AddButtonWrapper>
  );
}

AddButton.propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AddButton;



// WEBPACK FOOTER //
// ./src/modules/common/AddButton.js